var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 112,
    viewBox: "0 0 179 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1723_16995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6968 104.59H2.40285C2.08367 104.59 1.82495 104.86 1.82495 105.194V109.715C1.82495 110.048 2.08367 110.319 2.40285 110.319H31.6968C32.016 110.319 32.2747 110.048 32.2747 109.715V105.194C32.2747 104.86 32.016 104.59 31.6968 104.59Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.82495 109.711C1.82495 110.045 2.08367 110.315 2.40285 110.315H31.6968C32.016 110.315 32.2747 110.045 32.2747 109.711H1.82495Z",
    fill: "url(#paint0_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.82495 105.198C1.82495 104.864 2.08367 104.594 2.40285 104.594H31.6968C32.016 104.594 32.2747 104.864 32.2747 105.198H1.82495Z",
    fill: "url(#paint1_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4355 105.707H16.6641V109.203H17.4355V105.707Z",
    fill: "url(#paint2_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2147 105.707H14.4432V109.203H15.2147V105.707Z",
    fill: "url(#paint3_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9937 105.707H12.2223V109.203H12.9937V105.707Z",
    fill: "url(#paint4_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7728 105.707H10.0013V109.203H10.7728V105.707Z",
    fill: "url(#paint5_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55183 105.707H7.7804V109.203H8.55183V105.707Z",
    fill: "url(#paint6_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33102 105.707H5.55957V109.203H6.33102V105.707Z",
    fill: "url(#paint7_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11006 105.707H3.33862V109.203H4.11006V105.707Z",
    fill: "url(#paint8_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7612 105.707H29.9897V109.203H30.7612V105.707Z",
    fill: "url(#paint9_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5402 105.707H27.7688V109.203H28.5402V105.707Z",
    fill: "url(#paint10_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3193 105.707H25.5479V109.203H26.3193V105.707Z",
    fill: "url(#paint11_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0985 105.707H23.327V109.203H24.0985V105.707Z",
    fill: "url(#paint12_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8774 105.707H21.106V109.203H21.8774V105.707Z",
    fill: "url(#paint13_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6566 105.707H18.8851V109.203H19.6566V105.707Z",
    fill: "url(#paint14_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3484 98.8594H2.05446C1.73528 98.8594 1.47656 99.1299 1.47656 99.4637V103.984C1.47656 104.318 1.73528 104.589 2.05446 104.589H31.3484C31.6676 104.589 31.9263 104.318 31.9263 103.984V99.4637C31.9263 99.1299 31.6676 98.8594 31.3484 98.8594Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47668 103.984C1.47668 104.318 1.7354 104.589 2.05459 104.589H31.3486C31.6677 104.589 31.9265 104.318 31.9265 103.984H1.47668Z",
    fill: "url(#paint15_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47668 99.4636C1.47668 99.1299 1.7354 98.8594 2.05459 98.8594H31.3486C31.6677 98.8594 31.9265 99.1299 31.9265 99.4636H1.47668Z",
    fill: "url(#paint16_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0872 99.9766H16.3158V103.472H17.0872V99.9766Z",
    fill: "url(#paint17_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8663 99.9766H14.0948V103.472H14.8663V99.9766Z",
    fill: "url(#paint18_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6455 99.9766H11.874V103.472H12.6455V99.9766Z",
    fill: "url(#paint19_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4245 99.9766H9.65308V103.472H10.4245V99.9766Z",
    fill: "url(#paint20_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20357 99.9766H7.43213V103.472H8.20357V99.9766Z",
    fill: "url(#paint21_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98263 99.9766H5.21118V103.472H5.98263V99.9766Z",
    fill: "url(#paint22_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76167 99.9766H2.99023V103.472H3.76167V99.9766Z",
    fill: "url(#paint23_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4129 99.9766H29.6415V103.472H30.4129V99.9766Z",
    fill: "url(#paint24_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.192 99.9766H27.4205V103.472H28.192V99.9766Z",
    fill: "url(#paint25_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.971 99.9766H25.1996V103.472H25.971V99.9766Z",
    fill: "url(#paint26_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7501 99.9766H22.9786V103.472H23.7501V99.9766Z",
    fill: "url(#paint27_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5291 99.9766H20.7577V103.472H21.5291V99.9766Z",
    fill: "url(#paint28_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3083 99.9766H18.5369V103.472H19.3083V99.9766Z",
    fill: "url(#paint29_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8719 93.1289H0.577902C0.258716 93.1289 0 93.3994 0 93.7331V98.2538C0 98.5875 0.258716 98.858 0.577902 98.858H29.8719C30.1911 98.858 30.4498 98.5874 30.4498 98.2538V93.7331C30.4498 93.3994 30.1911 93.1289 29.8719 93.1289Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 98.2539C0 98.5876 0.258716 98.8581 0.577902 98.8581H29.8719C30.1911 98.8581 30.4498 98.5876 30.4498 98.2539H0Z",
    fill: "url(#paint30_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 93.7332C0 93.3995 0.258716 93.1289 0.577902 93.1289H29.8719C30.1911 93.1289 30.4498 93.3995 30.4498 93.7332H0Z",
    fill: "url(#paint31_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6106 94.2461H14.8391V97.7418H15.6106V94.2461Z",
    fill: "url(#paint32_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3896 94.2461H12.6182V97.7418H13.3896V94.2461Z",
    fill: "url(#paint33_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1688 94.2461H10.3973V97.7418H11.1688V94.2461Z",
    fill: "url(#paint34_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94783 94.2461H8.17639V97.7418H8.94783V94.2461Z",
    fill: "url(#paint35_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72688 94.2461H5.95544V97.7418H6.72688V94.2461Z",
    fill: "url(#paint36_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.50594 94.2461H3.7345V97.7418H4.50594V94.2461Z",
    fill: "url(#paint37_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.28499 94.2461H1.51355V97.7418H2.28499V94.2461Z",
    fill: "url(#paint38_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9362 94.2461H28.1648V97.7418H28.9362V94.2461Z",
    fill: "url(#paint39_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7153 94.2461H25.9438V97.7418H26.7153V94.2461Z",
    fill: "url(#paint40_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4943 94.2461H23.7229V97.7418H24.4943V94.2461Z",
    fill: "url(#paint41_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2734 94.2461H21.502V97.7418H22.2734V94.2461Z",
    fill: "url(#paint42_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0525 94.2461H19.281V97.7418H20.0525V94.2461Z",
    fill: "url(#paint43_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8316 94.2461H17.0602V97.7418H17.8316V94.2461Z",
    fill: "url(#paint44_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6968 87.3945H2.40285C2.08367 87.3945 1.82495 87.665 1.82495 87.9988V92.5195C1.82495 92.8532 2.08367 93.1237 2.40285 93.1237H31.6968C32.016 93.1237 32.2747 92.8532 32.2747 92.5195V87.9988C32.2747 87.665 32.016 87.3945 31.6968 87.3945Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.82495 92.5195C1.82495 92.8532 2.08367 93.1238 2.40285 93.1238H31.6968C32.016 93.1238 32.2747 92.8532 32.2747 92.5195H1.82495Z",
    fill: "url(#paint45_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.82495 87.9988C1.82495 87.665 2.08367 87.3945 2.40285 87.3945H31.6968C32.016 87.3945 32.2747 87.665 32.2747 87.9988H1.82495Z",
    fill: "url(#paint46_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4355 88.5117H16.6641V92.0075H17.4355V88.5117Z",
    fill: "url(#paint47_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2147 88.5117H14.4432V92.0075H15.2147V88.5117Z",
    fill: "url(#paint48_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9937 88.5117H12.2223V92.0075H12.9937V88.5117Z",
    fill: "url(#paint49_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7728 88.5117H10.0013V92.0075H10.7728V88.5117Z",
    fill: "url(#paint50_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55183 88.5117H7.7804V92.0075H8.55183V88.5117Z",
    fill: "url(#paint51_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33102 88.5117H5.55957V92.0075H6.33102V88.5117Z",
    fill: "url(#paint52_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11006 88.5117H3.33862V92.0075H4.11006V88.5117Z",
    fill: "url(#paint53_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7612 88.5117H29.9897V92.0075H30.7612V88.5117Z",
    fill: "url(#paint54_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5402 88.5117H27.7688V92.0075H28.5402V88.5117Z",
    fill: "url(#paint55_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3193 88.5117H25.5479V92.0075H26.3193V88.5117Z",
    fill: "url(#paint56_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0985 88.5117H23.327V92.0075H24.0985V88.5117Z",
    fill: "url(#paint57_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8774 88.5117H21.106V92.0075H21.8774V88.5117Z",
    fill: "url(#paint58_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6566 88.5117H18.8851V92.0075H19.6566V88.5117Z",
    fill: "url(#paint59_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5361 81.6641H1.24209C0.9229 81.6641 0.664185 81.9346 0.664185 82.2683V86.789C0.664185 87.1227 0.9229 87.3932 1.24209 87.3932H30.5361C30.8552 87.3932 31.114 87.1227 31.114 86.789V82.2683C31.114 81.9346 30.8552 81.6641 30.5361 81.6641Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.664062 86.7891C0.664062 87.1228 0.922778 87.3933 1.24196 87.3933H30.5359C30.8551 87.3933 31.1138 87.1227 31.1138 86.7891H0.664062Z",
    fill: "url(#paint60_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.664062 82.2683C0.664062 81.9346 0.922778 81.6641 1.24196 81.6641H30.5359C30.8551 81.6641 31.1138 81.9346 31.1138 82.2683H0.664062Z",
    fill: "url(#paint61_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2747 82.7812H15.5033V86.277H16.2747V82.7812Z",
    fill: "url(#paint62_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0537 82.7812H13.2822V86.277H14.0537V82.7812Z",
    fill: "url(#paint63_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8328 82.7812H11.0614V86.277H11.8328V82.7812Z",
    fill: "url(#paint64_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61189 82.7812H8.84045V86.277H9.61189V82.7812Z",
    fill: "url(#paint65_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39095 82.7812H6.61951V86.277H7.39095V82.7812Z",
    fill: "url(#paint66_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17012 82.7812H4.39868V86.277H5.17012V82.7812Z",
    fill: "url(#paint67_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.94905 82.7812H2.17761V86.277H2.94905V82.7812Z",
    fill: "url(#paint68_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6003 82.7812H28.8289V86.277H29.6003V82.7812Z",
    fill: "url(#paint69_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3793 82.7812H26.6079V86.277H27.3793V82.7812Z",
    fill: "url(#paint70_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1584 82.7812H24.387V86.277H25.1584V82.7812Z",
    fill: "url(#paint71_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9375 82.7812H22.166V86.277H22.9375V82.7812Z",
    fill: "url(#paint72_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7165 82.7812H19.9451V86.277H20.7165V82.7812Z",
    fill: "url(#paint73_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4956 82.7812H17.7241V86.277H18.4956V82.7812Z",
    fill: "url(#paint74_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6093 75.9453H3.31533C2.99614 75.9453 2.73743 76.2158 2.73743 76.5496V81.0703C2.73743 81.404 2.99614 81.6745 3.31533 81.6745H32.6093C32.9285 81.6745 33.1872 81.404 33.1872 81.0703V76.5496C33.1872 76.2158 32.9285 75.9453 32.6093 75.9453Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73743 81.0703C2.73743 81.404 2.99614 81.6746 3.31533 81.6746H32.6093C32.9285 81.6746 33.1872 81.404 33.1872 81.0703H2.73743Z",
    fill: "url(#paint75_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7373 76.5496C2.7373 76.2159 2.99602 75.9453 3.31521 75.9453H32.6092C32.9284 75.9453 33.1871 76.2158 33.1871 76.5496H2.7373Z",
    fill: "url(#paint76_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3481 77.0586H17.5767V80.5543H18.3481V77.0586Z",
    fill: "url(#paint77_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.127 77.0586H15.3556V80.5543H16.127V77.0586Z",
    fill: "url(#paint78_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9062 77.0586H13.1348V80.5543H13.9062V77.0586Z",
    fill: "url(#paint79_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6853 77.0586H10.9138V80.5543H11.6853V77.0586Z",
    fill: "url(#paint80_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46432 77.0586H8.69287V80.5543H9.46432V77.0586Z",
    fill: "url(#paint81_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24337 77.0586H6.47192V80.5543H7.24337V77.0586Z",
    fill: "url(#paint82_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02254 77.0586H4.2511V80.5543H5.02254V77.0586Z",
    fill: "url(#paint83_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6737 77.0586H30.9022V80.5543H31.6737V77.0586Z",
    fill: "url(#paint84_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4527 77.0586H28.6813V80.5543H29.4527V77.0586Z",
    fill: "url(#paint85_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2316 77.0586H26.4602V80.5543H27.2316V77.0586Z",
    fill: "url(#paint86_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0108 77.0586H24.2394V80.5543H25.0108V77.0586Z",
    fill: "url(#paint87_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7899 77.0586H22.0184V80.5543H22.7899V77.0586Z",
    fill: "url(#paint88_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5689 77.0586H19.7975V80.5543H20.5689V77.0586Z",
    fill: "url(#paint89_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6968 70.2109H2.40285C2.08367 70.2109 1.82495 70.4814 1.82495 70.8152V75.3359C1.82495 75.6696 2.08367 75.9401 2.40285 75.9401H31.6968C32.016 75.9401 32.2747 75.6696 32.2747 75.3359V70.8152C32.2747 70.4814 32.016 70.2109 31.6968 70.2109Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.82495 75.3359C1.82495 75.6697 2.08367 75.9402 2.40285 75.9402H31.6968C32.016 75.9402 32.2747 75.6697 32.2747 75.3359H1.82495Z",
    fill: "url(#paint90_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.82495 70.8152C1.82495 70.4815 2.08367 70.2109 2.40285 70.2109H31.6968C32.016 70.2109 32.2747 70.4815 32.2747 70.8152H1.82495Z",
    fill: "url(#paint91_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4355 71.3281H16.6641V74.8239H17.4355V71.3281Z",
    fill: "url(#paint92_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2147 71.3281H14.4432V74.8239H15.2147V71.3281Z",
    fill: "url(#paint93_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9937 71.3281H12.2223V74.8239H12.9937V71.3281Z",
    fill: "url(#paint94_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7728 71.3281H10.0013V74.8239H10.7728V71.3281Z",
    fill: "url(#paint95_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55183 71.3281H7.7804V74.8239H8.55183V71.3281Z",
    fill: "url(#paint96_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33102 71.3281H5.55957V74.8239H6.33102V71.3281Z",
    fill: "url(#paint97_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11006 71.3281H3.33862V74.8239H4.11006V71.3281Z",
    fill: "url(#paint98_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7612 71.3281H29.9897V74.8239H30.7612V71.3281Z",
    fill: "url(#paint99_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5402 71.3281H27.7688V74.8239H28.5402V71.3281Z",
    fill: "url(#paint100_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3193 71.3281H25.5479V74.8239H26.3193V71.3281Z",
    fill: "url(#paint101_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0985 71.3281H23.327V74.8239H24.0985V71.3281Z",
    fill: "url(#paint102_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8774 71.3281H21.106V74.8239H21.8774V71.3281Z",
    fill: "url(#paint103_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6566 71.3281H18.8851V74.8239H19.6566V71.3281Z",
    fill: "url(#paint104_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8577 64.4805H3.56374C3.24456 64.4805 2.98584 64.751 2.98584 65.0847V69.6053C2.98584 69.9391 3.24456 70.2096 3.56374 70.2096H32.8577C33.1769 70.2096 33.4356 69.9391 33.4356 69.6053V65.0847C33.4356 64.751 33.1769 64.4805 32.8577 64.4805Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98572 69.6055C2.98572 69.9392 3.24443 70.2098 3.56362 70.2098H32.8576C33.1768 70.2098 33.4355 69.9392 33.4355 69.6055H2.98572Z",
    fill: "url(#paint105_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98572 65.0847C2.98572 64.751 3.24443 64.4805 3.56362 64.4805H32.8576C33.1768 64.4805 33.4355 64.751 33.4355 65.0847H2.98572Z",
    fill: "url(#paint106_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5964 65.6016H17.825V69.0973H18.5964V65.6016Z",
    fill: "url(#paint107_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3754 65.6016H15.604V69.0973H16.3754V65.6016Z",
    fill: "url(#paint108_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1545 65.6016H13.3831V69.0973H14.1545V65.6016Z",
    fill: "url(#paint109_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9336 65.6016H11.1621V69.0973H11.9336V65.6016Z",
    fill: "url(#paint110_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71261 65.6016H8.94116V69.0973H9.71261V65.6016Z",
    fill: "url(#paint111_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49178 65.6016H6.72034V69.0973H7.49178V65.6016Z",
    fill: "url(#paint112_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27083 65.6016H4.49939V69.0973H5.27083V65.6016Z",
    fill: "url(#paint113_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9221 65.6016H31.1506V69.0973H31.9221V65.6016Z",
    fill: "url(#paint114_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.701 65.6016H28.9296V69.0973H29.701V65.6016Z",
    fill: "url(#paint115_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4801 65.6016H26.7086V69.0973H27.4801V65.6016Z",
    fill: "url(#paint116_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2592 65.6016H24.4878V69.0973H25.2592V65.6016Z",
    fill: "url(#paint117_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0383 65.6016H22.2668V69.0973H23.0383V65.6016Z",
    fill: "url(#paint118_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8173 65.6016H20.0459V69.0973H20.8173V65.6016Z",
    fill: "url(#paint119_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7843 58.75H1.49038C1.17119 58.75 0.912476 59.0205 0.912476 59.3542V63.8749C0.912476 64.2086 1.17119 64.4792 1.49038 64.4792H30.7843C31.1035 64.4792 31.3622 64.2086 31.3622 63.8749V59.3542C31.3622 59.0205 31.1035 58.75 30.7843 58.75Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.91272 63.875C0.91272 64.2087 1.17144 64.4793 1.49062 64.4793H30.7846C31.1038 64.4793 31.3625 64.2087 31.3625 63.875H0.91272Z",
    fill: "url(#paint120_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.912476 59.3543C0.912476 59.0206 1.17119 58.75 1.49038 58.75H30.7843C31.1035 58.75 31.3622 59.0206 31.3622 59.3543H0.912476Z",
    fill: "url(#paint121_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5233 59.8672H15.7518V63.3629H16.5233V59.8672Z",
    fill: "url(#paint122_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3023 59.8672H13.5309V63.3629H14.3023V59.8672Z",
    fill: "url(#paint123_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0814 59.8672H11.3099V63.3629H12.0814V59.8672Z",
    fill: "url(#paint124_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86043 59.8672H9.08899V63.3629H9.86043V59.8672Z",
    fill: "url(#paint125_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63948 59.8672H6.86804V63.3629H7.63948V59.8672Z",
    fill: "url(#paint126_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41853 59.8672H4.64709V63.3629H5.41853V59.8672Z",
    fill: "url(#paint127_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19759 59.8672H2.42615V63.3629H3.19759V59.8672Z",
    fill: "url(#paint128_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8488 59.8672H29.0774V63.3629H29.8488V59.8672Z",
    fill: "url(#paint129_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6279 59.8672H26.8564V63.3629H27.6279V59.8672Z",
    fill: "url(#paint130_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4069 59.8672H24.6355V63.3629H25.4069V59.8672Z",
    fill: "url(#paint131_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1861 59.8672H22.4147V63.3629H23.1861V59.8672Z",
    fill: "url(#paint132_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9651 59.8672H20.1936V63.3629H20.9651V59.8672Z",
    fill: "url(#paint133_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7441 59.8672H17.9727V63.3629H18.7441V59.8672Z",
    fill: "url(#paint134_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8577 53.0234H3.56374C3.24456 53.0234 2.98584 53.2939 2.98584 53.6277V58.1483C2.98584 58.482 3.24456 58.7525 3.56374 58.7525H32.8577C33.1769 58.7525 33.4356 58.482 33.4356 58.1483V53.6277C33.4356 53.2939 33.1769 53.0234 32.8577 53.0234Z",
    fill: "#FFDD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98572 58.1484C2.98572 58.4822 3.24443 58.7527 3.56362 58.7527H32.8576C33.1768 58.7527 33.4355 58.4821 33.4355 58.1484H2.98572Z",
    fill: "url(#paint135_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98572 53.6238C2.98572 53.2901 3.24443 53.0195 3.56362 53.0195H32.8576C33.1768 53.0195 33.4355 53.2901 33.4355 53.6238H2.98572Z",
    fill: "url(#paint136_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5964 54.1367H17.825V57.6325H18.5964V54.1367Z",
    fill: "url(#paint137_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3754 54.1367H15.604V57.6325H16.3754V54.1367Z",
    fill: "url(#paint138_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1545 54.1367H13.3831V57.6325H14.1545V54.1367Z",
    fill: "url(#paint139_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9336 54.1367H11.1621V57.6325H11.9336V54.1367Z",
    fill: "url(#paint140_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71261 54.1367H8.94116V57.6325H9.71261V54.1367Z",
    fill: "url(#paint141_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49178 54.1367H6.72034V57.6325H7.49178V54.1367Z",
    fill: "url(#paint142_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27083 54.1367H4.49939V57.6325H5.27083V54.1367Z",
    fill: "url(#paint143_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9221 54.1367H31.1506V57.6325H31.9221V54.1367Z",
    fill: "url(#paint144_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.701 54.1367H28.9296V57.6325H29.701V54.1367Z",
    fill: "url(#paint145_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4801 54.1367H26.7086V57.6325H27.4801V54.1367Z",
    fill: "url(#paint146_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2592 54.1367H24.4878V57.6325H25.2592V54.1367Z",
    fill: "url(#paint147_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0383 54.1367H22.2668V57.6325H23.0383V54.1367Z",
    fill: "url(#paint148_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8173 54.1367H20.0459V57.6325H20.8173V54.1367Z",
    fill: "url(#paint149_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.966 42.1145L153.034 48.2089C128.048 74.2772 111.131 80.7146 77.9802 83.2257V110.995C119.363 102.456 137.655 87.1026 161.92 57.1326L167.721 62.9581L179 31.0586L146.966 42.1145Z",
    fill: "url(#paint150_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7508 7.84766H58.8388C52.7992 7.84766 47.8855 12.7727 47.8855 18.8262V28.2762H55.3726V18.8262C55.3726 16.9105 56.9275 15.352 58.8388 15.352H92.7508C94.6622 15.352 96.217 16.9106 96.217 18.8262V28.2762H103.704V18.8262C103.704 12.7726 98.7904 7.84766 92.7508 7.84766Z",
    fill: "url(#paint151_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9509 51.8086C15.9509 51.8086 17.3672 91.7902 18.6745 104.902C19.0634 108.802 21.8449 111.999 25.7558 111.999H125.834C129.745 111.999 132.506 108.8 132.915 104.902C134.277 91.904 135.638 51.8086 135.638 51.8086H15.9509Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.002 27.8516H23.5875C18.7673 27.8516 14.8597 31.7681 14.8597 36.5995V52.0986C14.8597 53.4306 15.9973 54.1136 17.2659 54.5103C32.52 59.2813 75.9223 71.0085 75.9223 71.0085C75.9223 71.0085 120.235 58.3654 134.324 54.5103C135.605 54.1595 136.73 53.4306 136.73 52.0986V36.5995C136.73 31.7681 132.822 27.8516 128.002 27.8516Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.39 74.1097V64.8252C87.39 63.0039 85.9169 61.5273 84.0998 61.5273H67.4893C65.6722 61.5273 64.1991 63.0038 64.1991 64.8252V74.1097C64.1991 75.931 65.6722 77.4075 67.4893 77.4075H84.0998C85.9169 77.4074 87.39 75.931 87.39 74.1097Z",
    fill: "url(#paint152_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9262 71.1535V67.7798C82.9262 66.4581 81.8573 65.3867 80.5386 65.3867H71.0504C69.7317 65.3867 68.6628 66.4582 68.6628 67.7798V71.1535C68.6628 72.4751 69.7317 73.5465 71.0504 73.5465H80.5386C81.8573 73.5466 82.9262 72.4752 82.9262 71.1535Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.277 9.8647L123.629 9.73785L123.387 5.22656L121.95 5.30405L121.277 9.8647Z",
    fill: "#EFBC90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.175 3.16191C118.876 5.03511 119.27 6.88654 120.407 7.23138C121.474 7.55488 123.236 6.45223 123.968 4.57679C124.739 2.60233 124.235 1.1849 122.657 0.732088C120.981 0.250963 119.502 1.10857 119.175 3.16191Z",
    fill: "#F4CAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.419 5.81277L123.165 5.72434C123.165 5.72434 123.215 4.84296 123.044 4.6269C122.824 4.34956 121.796 4.43503 121.796 4.43503C121.796 4.43503 121.704 3.45844 121.301 3.21703C120.943 3.00284 119.503 2.92197 118.962 3.24032C118.962 3.24032 118.664 2.31593 119.04 1.44962C119.454 0.494505 120.275 0.155531 121.318 0.0470755C122.361 -0.0613803 123.486 0.0607438 123.782 1.22006C123.782 1.22006 124.687 1.36717 124.753 2.6041C124.819 3.84115 123.419 5.81277 123.419 5.81277Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.187 4.64184C123.309 4.32432 123.194 3.9843 122.93 3.88238C122.666 3.78045 122.353 3.95521 122.231 4.27273C122.109 4.59025 122.224 4.93028 122.488 5.03221C122.752 5.13414 123.065 4.95936 123.187 4.64184Z",
    fill: "#F4CAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.613 38.9724L106.834 27.3912C106.942 27.0046 107.251 26.6853 107.669 26.5858L107.826 26.5485L120.617 23.501L122.655 23.0156L123.414 27.3981L121.333 27.6297L108.932 29.0092L104.573 39.309L104.374 39.7793L103.476 39.4645L103.613 38.9724Z",
    fill: "#EFBC90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.014 27.2553L108.178 27.2187L120.605 24.4412L122.649 23.9844L123.34 28.3868L121.254 28.5809L113.394 29.3121L119.327 31.945L119.793 32.1518L119.469 33.0451L118.979 32.903L107.938 29.6983C107.512 29.5736 107.163 29.2261 107.059 28.7611C106.908 28.0811 107.335 27.4069 108.014 27.2553Z",
    fill: "#F4CAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.505 22.6055C116.286 24.505 108.282 24.6975 106.656 26.3521C104.978 28.0594 103.867 36.981 103.867 36.981L105.732 37.6331C105.732 37.6331 108.785 29.291 109.287 28.9503C109.793 28.6065 120.593 29.6746 123.342 28.0064C125.62 26.624 124.618 22.8997 124.618 22.8997L118.505 22.6055Z",
    fill: "url(#paint153_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.474 22.6523C117.876 24.9771 107.354 25.1485 106.679 27.6705C105.943 30.4235 117.461 32.8284 117.461 32.8284L118.053 30.9685C118.053 30.9685 113.767 29.599 113.847 29.3675C113.921 29.1518 121.587 30.1414 124.31 28.0532C126.426 26.4316 125.586 22.9466 125.586 22.9466L119.474 22.6523Z",
    fill: "url(#paint154_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.672 11.8261L119.373 20.5556L120.178 19.9746L113.663 19.908L113.062 19.9018L113.014 21.0688L113.614 21.1123L120.112 21.583C120.475 21.6094 120.799 21.3782 120.903 21.0437L120.916 21.002L123.611 12.3872L123.913 11.4216L121.93 10.8477L121.672 11.8261Z",
    fill: "#EFBC90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.726 12.3007C124.699 14.4344 122.893 19.8237 120.574 21.5346C119.197 22.5507 114.965 21.4351 114.965 21.4351L114.899 19.748C114.899 19.748 118.162 20.2581 119.049 18.4609C119.935 16.6635 120.715 11.8694 121.86 11.1871C122.868 10.5859 124.738 11.342 124.726 12.3007Z",
    fill: "#26575D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.581 9.24609C123.581 9.24609 122.294 10.2716 121.094 9.4889C121.094 9.4889 120.455 13.9892 119.814 15.807C119.173 17.6249 117.317 22.3928 117.317 22.3928L126.292 22.8247C126.73 18.7091 125.399 13.9462 123.581 9.24609Z",
    fill: "#76D3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.929 8.84375C123.929 8.84375 127.911 15.4807 126.709 22.2979C126.709 22.2979 127.013 23.663 122.154 23.245C117.295 22.827 117.049 22.1399 117.049 22.1399C118.766 18.5331 120.163 14.4245 120.998 9.43689C120.998 9.43689 122.814 9.59157 123.929 8.84375Z",
    fill: "url(#paint155_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.499 20.0838C110.472 20.4973 111.057 21.0434 111.923 21.2078C112.721 21.3593 113.306 20.9619 113.357 20.5465C113.473 19.6188 110.541 19.4441 110.499 20.0838Z",
    fill: "#EFBC90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.202 19.3462C111.281 19.1822 111.779 19.1675 112.366 19.3874C112.908 19.5903 113.185 19.9295 113.121 20.1022C112.977 20.4878 111.079 19.5998 111.202 19.3462Z",
    fill: "#EFBC90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.568 9.35637C121.568 9.35637 121.276 13.3263 120.234 17.5906C119.191 21.8549 117.783 24.629 117.783 24.629C117.783 24.629 126.202 25.5529 127.77 23.5328C129.183 21.713 126.086 11.0496 124.246 8.65234L121.568 9.35637Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.686 37.6039L118.795 36.7046L118.795 36.7048L118.543 33.2171L118.568 33.2247C118.568 33.2247 119.113 33.3506 119.411 32.7339C119.631 32.2794 119.598 31.9311 119.566 31.7789C119.547 31.7393 119.539 31.7088 119.543 31.6948C119.607 31.4865 119.998 31.4219 120.417 31.5505C120.555 31.5928 120.678 31.6507 120.78 31.7167L121.362 31.8953L119.465 38.1066L118.875 37.9257C118.738 37.8837 118.656 37.7441 118.686 37.6039Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1426 39.9125L100.039 39.8007V39.8011L103.354 38.7109L103.353 38.7372C103.353 38.7372 103.363 39.2973 104.032 39.4378C104.526 39.5413 104.855 39.4254 104.994 39.3572C105.028 39.3292 105.055 39.3137 105.07 39.3144C105.287 39.3258 105.444 39.6907 105.422 40.1295C105.414 40.2736 105.388 40.4073 105.349 40.522L105.317 41.1313L98.8447 40.7917L98.8769 40.1745C98.8844 40.0315 98.9996 39.9177 99.1426 39.9125Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.43 22.6308L106.626 22.2551L106.66 21.5391L114.464 21.9146L114.43 22.6308Z",
    fill: "url(#paint156_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.708 22.5008L106.619 22.2559L106.097 17.1758L111.185 17.4206L111.708 22.5008Z",
    fill: "#B0BABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.013 19.1272C109.004 19.3196 108.808 19.4666 108.576 19.4554C108.344 19.4442 108.163 19.2792 108.172 19.0867C108.182 18.8942 108.377 18.7472 108.609 18.7584C108.841 18.7696 109.022 18.9347 109.013 19.1272Z",
    fill: "url(#paint157_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.988 11.8692L121.408 21.0306L122.085 20.3042L115.574 21.5214L114.982 21.632L115.161 22.7868L115.758 22.7126L122.331 21.895C122.694 21.8499 122.966 21.5601 123.004 21.2114L123.008 21.1687L123.999 12.0428L124.109 11.0368L122.052 10.8594L121.988 11.8692Z",
    fill: "#F4CAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.55 22.427C112.613 22.8366 113.303 23.2418 114.184 23.213C114.996 23.1864 115.48 22.6708 115.44 22.2542C115.351 21.3235 112.452 21.7936 112.55 22.427Z",
    fill: "#F4CAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.076 21.555C113.118 21.3776 113.6 21.2543 114.221 21.3408C114.794 21.4204 115.138 21.6909 115.113 21.8734C115.057 22.2812 113.011 21.8293 113.076 21.555Z",
    fill: "#F4CAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.11 11.7325C125.643 13.8353 124.751 19.5737 122.775 21.7385C121.601 23.024 117.171 22.7721 117.171 22.7721L116.773 21.1023C116.773 21.1023 120.064 21.2316 120.595 19.2637C121.126 17.2957 121.045 11.7639 122.052 10.8572C122.94 10.0583 124.822 10.5966 125.11 11.7325Z",
    fill: "#4D7479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8626 11.6601L27.6808 11.0586L28.8288 6.875L30.1621 7.24259L29.8626 11.6601Z",
    fill: "#EFBC90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.203 5.80215C33.1005 7.62103 32.3529 9.27757 31.2155 9.368C30.1485 9.4528 28.7206 8.05692 28.4162 6.14687C28.0957 4.136 28.8582 2.90935 30.4312 2.80797C32.1022 2.70024 33.3153 3.80833 33.203 5.80215Z",
    fill: "#F4CAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2636 5.73698C30.6143 5.0733 31.3095 4.90031 31.836 4.84091C32.3625 4.78151 33.2162 5.01687 33.3206 4.63652C33.4249 4.25617 33.2093 2.84576 31.0558 2.47805C29.1064 2.14518 27.8874 3.24099 27.4011 4.64105C26.9757 5.866 27.6928 7.27369 28.6663 7.08412C29.6398 6.89455 29.839 6.54039 30.2636 5.73698Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1623 6.32376C30.2091 6.64713 30.0291 6.94099 29.7602 6.98006C29.4914 7.01914 29.2354 6.78868 29.1887 6.46531C29.1419 6.14194 29.3219 5.84808 29.5908 5.80901C29.8596 5.76993 30.1155 6.00039 30.1623 6.32376Z",
    fill: "#F4CAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9694 0.617587C31.2925 1.45063 30.8413 2.7694 29.8096 3.17141C28.7778 3.57348 27.5564 2.90653 27.2333 2.07354C26.9101 1.2405 27.6693 0.715638 28.701 0.313572C29.7327 -0.0884947 30.6463 -0.21546 30.9694 0.617587Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3204 21.7221C40.3011 22.1197 39.6838 22.5766 38.8395 22.6384C38.0611 22.6954 37.5469 22.252 37.5429 21.85C37.5339 20.9522 40.3504 21.1072 40.3204 21.7221Z",
    fill: "#EFBC90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2289 26.1177L41.0719 26.0886L29.8266 24.0036L27.8479 23.6367L27.3555 27.9062L29.3655 28.0015L39.1209 28.4642L35.1728 37.9718L34.9848 38.4246L35.8079 38.8292L36.05 38.4029L42.0371 27.86C42.0992 27.7495 42.1471 27.6229 42.1714 27.4913C42.2896 26.8511 41.8676 26.2361 41.2289 26.1177Z",
    fill: "#EFBC90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3185 26.7053L42.1757 26.679L29.6997 24.3768L27.7216 24.0117L27.2075 28.2514L29.2153 28.3719L40.8564 29.0706L41.495 41.1148L41.5209 41.6045L42.4427 41.6076L42.4719 41.1181L43.2598 27.9095C43.2946 27.3353 42.8972 26.8121 42.3185 26.7053Z",
    fill: "#EFBC90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3052 23.0078C32.7309 25.3117 41.2067 24.5148 42.4279 26.206C44.0573 28.4622 37.3626 37.1825 37.3626 37.1825L35.1345 35.9355C35.1345 35.9355 38.5475 29.7674 38.41 29.3249C38.2354 28.7628 28.9338 30.0945 26.417 27.9656C24.4625 26.3123 25.4278 23.0079 25.4278 23.0079L31.3052 23.0078Z",
    fill: "#4D7479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6413 23.0078C31.8852 25.838 41.9954 24.7923 43.4291 27.2597C44.5857 29.2501 43.3978 39.3552 43.3978 39.3552L40.7232 39.2823C40.7232 39.2823 40.7377 30.6791 40.214 30.0952C39.8289 29.6659 29.0954 30.6573 26.417 28.7366C24.1238 27.0921 25.4278 23.0078 25.4278 23.0078H30.6413Z",
    fill: "#4D7479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1639 12.5783L31.6835 21.2621L30.9607 20.6405L37.3048 21.1126L37.881 21.1555L37.8321 22.2767L37.2544 22.2691L30.8934 22.1851C30.5427 22.1805 30.2521 21.9326 30.1793 21.6037L30.1705 21.5634L28.2623 12.9571L28.0519 12.0084L29.9963 11.6211L30.1639 12.5783Z",
    fill: "#EFBC90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1694 12.779C27.0192 14.8573 28.3601 20.2568 30.4751 22.1139C31.7311 23.2166 35.9126 22.4761 35.9126 22.4761L36.1163 20.84C36.1163 20.84 32.9878 21.3122 32.2735 19.4899C31.5592 17.6676 31.1074 12.6919 30.05 11.9332C29.1182 11.2645 27.2369 11.8452 27.1694 12.779Z",
    fill: "url(#paint158_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7805 10.4883C27.7805 10.4883 23.4571 16.5334 24.082 23.1526C24.082 23.1526 23.6857 24.4358 28.3692 24.4121C33.0527 24.3883 33.3415 23.7496 33.3415 23.7496C31.9757 20.1638 30.9557 16.1225 30.541 11.2832C30.541 11.2832 28.79 11.2905 27.7805 10.4883Z",
    fill: "url(#paint159_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1715 13.9285C28.5404 14.9184 27.9246 15.9534 27.3555 16.9889C27.0713 17.5083 26.7975 18.0317 26.5455 18.5582C26.2946 19.0836 26.0614 19.6164 25.8894 20.1339C25.8469 20.2637 25.811 20.3873 25.7782 20.5143L25.68 20.9344C25.6199 21.2199 25.5615 21.5071 25.5093 21.7987C25.404 22.3812 25.3113 22.9712 25.2257 23.5636C25.0577 24.7484 24.9133 25.9469 24.792 27.1378L24.7333 27.7139L23.6139 27.6362L23.6398 27.0578C23.6945 25.8369 23.7709 24.6268 23.8733 23.4085C23.9263 22.7997 23.9865 22.1902 24.0617 21.5772C24.0988 21.2708 24.1433 20.9623 24.1904 20.6528L24.2721 20.1842C24.3057 20.0163 24.3456 19.8472 24.3891 19.6873C24.5662 19.0468 24.7917 18.4584 25.0314 17.8797C25.2721 17.3024 25.5306 16.7402 25.7982 16.1845C26.3374 15.072 26.9036 13.9972 27.517 12.9155L27.9963 12.0703L29.6936 13.1096L29.1715 13.9285Z",
    fill: "#F4CAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.225 11.8653C25.6749 13.2539 24.6744 16.5183 23.9214 19.2336C23.1685 21.949 23.4992 26.137 23.4992 26.137L25.2 26.2876C25.2 26.2876 25.4838 22.0525 26.2352 20.2452C26.9866 18.438 30.1148 14.5481 29.8816 13.2658C29.6761 12.1359 27.9214 11.2415 27.225 11.8653Z",
    fill: "url(#paint160_linear_1723_16995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5847 31.0561C23.199 30.9605 22.9164 30.0336 23.0835 28.8633C23.2374 27.7844 23.8119 27.155 24.2082 27.2193C25.0931 27.3628 24.1811 31.2039 23.5847 31.0561Z",
    fill: "#F4CAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7236 29.5654C24.8963 29.539 25.0513 29.0853 25.0166 28.4829C24.9847 27.9276 24.753 27.5761 24.5768 27.5861C24.183 27.6085 24.4566 29.6065 24.7236 29.5654Z",
    fill: "#F4CAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9898 42.1137L45.2897 41.9889V41.9892L42.7299 40.9961V41.0168C42.7299 41.0168 42.6989 41.4565 42.1674 41.5392C41.7757 41.6002 41.5217 41.4956 41.4149 41.4363C41.3895 41.4129 41.3686 41.3996 41.357 41.3996C41.186 41.3996 41.0475 41.6798 41.0475 42.0255C41.0475 42.139 41.0626 42.2451 41.0888 42.3369V42.8169H46.1877V42.3307C46.1877 42.2179 46.1018 42.1238 45.9898 42.1137Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.122 41.4295L37.6468 40.8992L37.6466 40.8994L36.2391 38.5375L36.2264 38.5538C36.2264 38.5538 35.932 38.8812 35.4622 38.6185C35.116 38.4249 34.9802 38.1858 34.9324 38.0732C34.9268 38.0391 34.9184 38.0156 34.9093 38.0085C34.7746 37.903 34.4933 38.0384 34.281 38.3108C34.2113 38.4003 34.1581 38.4932 34.1223 38.5817L33.8275 38.96L37.846 42.1057L38.1446 41.7225C38.214 41.6336 38.2041 41.5065 38.122 41.4295Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6136 21.0119C39.5639 20.8441 39.0944 20.7521 38.5037 20.8686C37.9592 20.976 37.6433 21.2539 37.6773 21.4276C37.7531 21.8155 39.6905 21.2715 39.6136 21.0119Z",
    fill: "#EFBC90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3184 16.0339C44.1125 15.9687 43.8929 16.0831 43.8279 16.2894L42.2979 21.141H37.7106C37.4947 21.141 37.3197 21.3164 37.3197 21.5328C37.3197 21.7491 37.4947 21.9245 37.7106 21.9245H42.5905C42.788 21.9245 42.9509 21.7774 42.9772 21.5867L44.5732 16.5256C44.6383 16.3193 44.5242 16.0992 44.3184 16.0339Z",
    fill: "#26575D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2977 21.1415H42.5406L44.0273 16.3711H43.8022L42.2977 21.1415Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1723_16995",
    x1: 1.82492,
    y1: 110.013,
    x2: 32.2747,
    y2: 110.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1723_16995",
    x1: 1.82492,
    y1: 104.896,
    x2: 32.2747,
    y2: 104.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1723_16995",
    x1: 16.6641,
    y1: 107.455,
    x2: 17.4355,
    y2: 107.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1723_16995",
    x1: 14.4432,
    y1: 107.455,
    x2: 15.2147,
    y2: 107.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1723_16995",
    x1: 12.2223,
    y1: 107.455,
    x2: 12.9937,
    y2: 107.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1723_16995",
    x1: 10.0013,
    y1: 107.455,
    x2: 10.7728,
    y2: 107.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1723_16995",
    x1: 7.78043,
    y1: 107.455,
    x2: 8.55186,
    y2: 107.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1723_16995",
    x1: 5.55957,
    y1: 107.455,
    x2: 6.33101,
    y2: 107.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1723_16995",
    x1: 3.3386,
    y1: 107.455,
    x2: 4.11003,
    y2: 107.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1723_16995",
    x1: 29.9898,
    y1: 107.455,
    x2: 30.7612,
    y2: 107.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1723_16995",
    x1: 27.7688,
    y1: 107.455,
    x2: 28.5402,
    y2: 107.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1723_16995",
    x1: 25.5479,
    y1: 107.455,
    x2: 26.3193,
    y2: 107.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1723_16995",
    x1: 23.327,
    y1: 107.455,
    x2: 24.0985,
    y2: 107.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1723_16995",
    x1: 21.106,
    y1: 107.455,
    x2: 21.8774,
    y2: 107.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1723_16995",
    x1: 18.8851,
    y1: 107.455,
    x2: 19.6566,
    y2: 107.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1723_16995",
    x1: 1.47671,
    y1: 104.287,
    x2: 31.9265,
    y2: 104.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1723_16995",
    x1: 1.47671,
    y1: 99.1615,
    x2: 31.9265,
    y2: 99.1615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1723_16995",
    x1: 16.3158,
    y1: 101.724,
    x2: 17.0873,
    y2: 101.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1723_16995",
    x1: 14.0948,
    y1: 101.724,
    x2: 14.8663,
    y2: 101.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1723_16995",
    x1: 11.874,
    y1: 101.724,
    x2: 12.6454,
    y2: 101.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1723_16995",
    x1: 9.65308,
    y1: 101.724,
    x2: 10.4245,
    y2: 101.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1723_16995",
    x1: 7.4321,
    y1: 101.724,
    x2: 8.20354,
    y2: 101.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1723_16995",
    x1: 5.21119,
    y1: 101.724,
    x2: 5.98263,
    y2: 101.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1723_16995",
    x1: 2.99021,
    y1: 101.724,
    x2: 3.76164,
    y2: 101.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1723_16995",
    x1: 29.6415,
    y1: 101.724,
    x2: 30.4129,
    y2: 101.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1723_16995",
    x1: 27.4205,
    y1: 101.724,
    x2: 28.192,
    y2: 101.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1723_16995",
    x1: 25.1996,
    y1: 101.724,
    x2: 25.971,
    y2: 101.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1723_16995",
    x1: 22.9786,
    y1: 101.724,
    x2: 23.7501,
    y2: 101.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1723_16995",
    x1: 20.7577,
    y1: 101.724,
    x2: 21.5292,
    y2: 101.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1723_16995",
    x1: 18.5369,
    y1: 101.724,
    x2: 19.3083,
    y2: 101.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1723_16995",
    x1: 0.0000181047,
    y1: 98.556,
    x2: 30.4498,
    y2: 98.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1723_16995",
    x1: 0.0000181047,
    y1: 93.4311,
    x2: 30.4498,
    y2: 93.4311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1723_16995",
    x1: 14.8391,
    y1: 95.994,
    x2: 15.6106,
    y2: 95.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1723_16995",
    x1: 12.6181,
    y1: 95.994,
    x2: 13.3896,
    y2: 95.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1723_16995",
    x1: 10.3974,
    y1: 95.994,
    x2: 11.1688,
    y2: 95.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1723_16995",
    x1: 8.17638,
    y1: 95.994,
    x2: 8.94781,
    y2: 95.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1723_16995",
    x1: 5.95546,
    y1: 95.994,
    x2: 6.7269,
    y2: 95.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1723_16995",
    x1: 3.73449,
    y1: 95.994,
    x2: 4.50592,
    y2: 95.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1723_16995",
    x1: 1.51357,
    y1: 95.994,
    x2: 2.285,
    y2: 95.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1723_16995",
    x1: 28.1648,
    y1: 95.994,
    x2: 28.9362,
    y2: 95.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1723_16995",
    x1: 25.9438,
    y1: 95.994,
    x2: 26.7152,
    y2: 95.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1723_16995",
    x1: 23.7229,
    y1: 95.994,
    x2: 24.4943,
    y2: 95.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1723_16995",
    x1: 21.5019,
    y1: 95.994,
    x2: 22.2734,
    y2: 95.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1723_16995",
    x1: 19.281,
    y1: 95.994,
    x2: 20.0525,
    y2: 95.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1723_16995",
    x1: 17.0602,
    y1: 95.994,
    x2: 17.8316,
    y2: 95.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1723_16995",
    x1: 1.82492,
    y1: 92.8217,
    x2: 32.2747,
    y2: 92.8217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1723_16995",
    x1: 1.82492,
    y1: 87.6966,
    x2: 32.2747,
    y2: 87.6966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1723_16995",
    x1: 16.6641,
    y1: 90.2596,
    x2: 17.4355,
    y2: 90.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1723_16995",
    x1: 14.4432,
    y1: 90.2596,
    x2: 15.2147,
    y2: 90.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1723_16995",
    x1: 12.2223,
    y1: 90.2596,
    x2: 12.9937,
    y2: 90.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1723_16995",
    x1: 10.0013,
    y1: 90.2596,
    x2: 10.7728,
    y2: 90.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1723_16995",
    x1: 7.78043,
    y1: 90.2596,
    x2: 8.55186,
    y2: 90.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1723_16995",
    x1: 5.55957,
    y1: 90.2596,
    x2: 6.33101,
    y2: 90.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1723_16995",
    x1: 3.3386,
    y1: 90.2596,
    x2: 4.11003,
    y2: 90.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1723_16995",
    x1: 29.9898,
    y1: 90.2596,
    x2: 30.7612,
    y2: 90.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1723_16995",
    x1: 27.7688,
    y1: 90.2596,
    x2: 28.5402,
    y2: 90.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1723_16995",
    x1: 25.5479,
    y1: 90.2596,
    x2: 26.3193,
    y2: 90.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1723_16995",
    x1: 23.327,
    y1: 90.2596,
    x2: 24.0985,
    y2: 90.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1723_16995",
    x1: 21.106,
    y1: 90.2596,
    x2: 21.8774,
    y2: 90.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1723_16995",
    x1: 18.8851,
    y1: 90.2596,
    x2: 19.6566,
    y2: 90.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1723_16995",
    x1: 0.664062,
    y1: 87.0912,
    x2: 31.1138,
    y2: 87.0912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1723_16995",
    x1: 0.664062,
    y1: 81.9662,
    x2: 31.1138,
    y2: 81.9662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1723_16995",
    x1: 15.5033,
    y1: 84.5291,
    x2: 16.2747,
    y2: 84.5291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1723_16995",
    x1: 13.2823,
    y1: 84.5291,
    x2: 14.0537,
    y2: 84.5291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1723_16995",
    x1: 11.0614,
    y1: 84.5291,
    x2: 11.8328,
    y2: 84.5291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1723_16995",
    x1: 8.84043,
    y1: 84.5291,
    x2: 9.61186,
    y2: 84.5291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1723_16995",
    x1: 6.61951,
    y1: 84.5291,
    x2: 7.39094,
    y2: 84.5291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1723_16995",
    x1: 4.39865,
    y1: 84.5291,
    x2: 5.17008,
    y2: 84.5291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1723_16995",
    x1: 2.17762,
    y1: 84.5291,
    x2: 2.94904,
    y2: 84.5291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1723_16995",
    x1: 28.8288,
    y1: 84.5291,
    x2: 29.6003,
    y2: 84.5291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1723_16995",
    x1: 26.6079,
    y1: 84.5291,
    x2: 27.3794,
    y2: 84.5291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1723_16995",
    x1: 24.3869,
    y1: 84.5291,
    x2: 25.1584,
    y2: 84.5291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1723_16995",
    x1: 22.166,
    y1: 84.5291,
    x2: 22.9375,
    y2: 84.5291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1723_16995",
    x1: 19.9451,
    y1: 84.5291,
    x2: 20.7165,
    y2: 84.5291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1723_16995",
    x1: 17.7241,
    y1: 84.5291,
    x2: 18.4956,
    y2: 84.5291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1723_16995",
    x1: 2.7374,
    y1: 81.3724,
    x2: 33.1872,
    y2: 81.3724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1723_16995",
    x1: 2.73728,
    y1: 76.2475,
    x2: 33.187,
    y2: 76.2475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1723_16995",
    x1: 17.5766,
    y1: 78.8065,
    x2: 18.3481,
    y2: 78.8065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1723_16995",
    x1: 15.3556,
    y1: 78.8065,
    x2: 16.127,
    y2: 78.8065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1723_16995",
    x1: 13.1347,
    y1: 78.8065,
    x2: 13.9062,
    y2: 78.8065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1723_16995",
    x1: 10.9138,
    y1: 78.8065,
    x2: 11.6853,
    y2: 78.8065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1723_16995",
    x1: 8.69285,
    y1: 78.8065,
    x2: 9.46428,
    y2: 78.8065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1723_16995",
    x1: 6.47193,
    y1: 78.8065,
    x2: 7.24338,
    y2: 78.8065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1723_16995",
    x1: 4.25108,
    y1: 78.8065,
    x2: 5.02252,
    y2: 78.8065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1723_16995",
    x1: 30.9022,
    y1: 78.8065,
    x2: 31.6737,
    y2: 78.8065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1723_16995",
    x1: 28.6813,
    y1: 78.8065,
    x2: 29.4527,
    y2: 78.8065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1723_16995",
    x1: 26.4602,
    y1: 78.8065,
    x2: 27.2317,
    y2: 78.8065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1723_16995",
    x1: 24.2394,
    y1: 78.8065,
    x2: 25.0108,
    y2: 78.8065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1723_16995",
    x1: 22.0185,
    y1: 78.8065,
    x2: 22.7899,
    y2: 78.8065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1723_16995",
    x1: 19.7975,
    y1: 78.8065,
    x2: 20.5689,
    y2: 78.8065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1723_16995",
    x1: 1.82492,
    y1: 75.6381,
    x2: 32.2747,
    y2: 75.6381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1723_16995",
    x1: 1.82492,
    y1: 70.5131,
    x2: 32.2747,
    y2: 70.5131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1723_16995",
    x1: 16.6641,
    y1: 73.076,
    x2: 17.4355,
    y2: 73.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1723_16995",
    x1: 14.4432,
    y1: 73.076,
    x2: 15.2147,
    y2: 73.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_1723_16995",
    x1: 12.2223,
    y1: 73.076,
    x2: 12.9937,
    y2: 73.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1723_16995",
    x1: 10.0013,
    y1: 73.076,
    x2: 10.7728,
    y2: 73.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_1723_16995",
    x1: 7.78043,
    y1: 73.076,
    x2: 8.55186,
    y2: 73.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_1723_16995",
    x1: 5.55957,
    y1: 73.076,
    x2: 6.33101,
    y2: 73.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_1723_16995",
    x1: 3.3386,
    y1: 73.076,
    x2: 4.11003,
    y2: 73.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_1723_16995",
    x1: 29.9898,
    y1: 73.076,
    x2: 30.7612,
    y2: 73.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_1723_16995",
    x1: 27.7688,
    y1: 73.076,
    x2: 28.5402,
    y2: 73.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_1723_16995",
    x1: 25.5479,
    y1: 73.076,
    x2: 26.3193,
    y2: 73.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_1723_16995",
    x1: 23.327,
    y1: 73.076,
    x2: 24.0985,
    y2: 73.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_1723_16995",
    x1: 21.106,
    y1: 73.076,
    x2: 21.8774,
    y2: 73.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_1723_16995",
    x1: 18.8851,
    y1: 73.076,
    x2: 19.6566,
    y2: 73.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_1723_16995",
    x1: 2.98572,
    y1: 69.9076,
    x2: 33.4355,
    y2: 69.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_1723_16995",
    x1: 2.98572,
    y1: 64.7826,
    x2: 33.4355,
    y2: 64.7826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_1723_16995",
    x1: 17.8249,
    y1: 67.3495,
    x2: 18.5964,
    y2: 67.3495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_1723_16995",
    x1: 15.604,
    y1: 67.3495,
    x2: 16.3755,
    y2: 67.3495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_1723_16995",
    x1: 13.3831,
    y1: 67.3495,
    x2: 14.1545,
    y2: 67.3495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_1723_16995",
    x1: 11.1621,
    y1: 67.3495,
    x2: 11.9336,
    y2: 67.3495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_1723_16995",
    x1: 8.94116,
    y1: 67.3495,
    x2: 9.7126,
    y2: 67.3495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_1723_16995",
    x1: 6.72031,
    y1: 67.3495,
    x2: 7.49175,
    y2: 67.3495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_1723_16995",
    x1: 4.4994,
    y1: 67.3495,
    x2: 5.27083,
    y2: 67.3495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_1723_16995",
    x1: 31.1506,
    y1: 67.3495,
    x2: 31.9221,
    y2: 67.3495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_1723_16995",
    x1: 28.9296,
    y1: 67.3495,
    x2: 29.701,
    y2: 67.3495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_1723_16995",
    x1: 26.7086,
    y1: 67.3495,
    x2: 27.48,
    y2: 67.3495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_1723_16995",
    x1: 24.4878,
    y1: 67.3495,
    x2: 25.2593,
    y2: 67.3495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_1723_16995",
    x1: 22.2668,
    y1: 67.3495,
    x2: 23.0383,
    y2: 67.3495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_1723_16995",
    x1: 20.0459,
    y1: 67.3495,
    x2: 20.8174,
    y2: 67.3495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_1723_16995",
    x1: 0.912744,
    y1: 64.1771,
    x2: 31.3625,
    y2: 64.1771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_1723_16995",
    x1: 0.9125,
    y1: 59.0522,
    x2: 31.3623,
    y2: 59.0522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_1723_16995",
    x1: 15.7518,
    y1: 61.6151,
    x2: 16.5233,
    y2: 61.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_1723_16995",
    x1: 13.5309,
    y1: 61.6151,
    x2: 14.3023,
    y2: 61.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_1723_16995",
    x1: 11.31,
    y1: 61.6151,
    x2: 12.0814,
    y2: 61.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_1723_16995",
    x1: 9.08898,
    y1: 61.6151,
    x2: 9.86042,
    y2: 61.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_1723_16995",
    x1: 6.86807,
    y1: 61.6151,
    x2: 7.6395,
    y2: 61.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_1723_16995",
    x1: 4.64709,
    y1: 61.6151,
    x2: 5.41852,
    y2: 61.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_1723_16995",
    x1: 2.42618,
    y1: 61.6151,
    x2: 3.19761,
    y2: 61.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_1723_16995",
    x1: 29.0774,
    y1: 61.6151,
    x2: 29.8488,
    y2: 61.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_1723_16995",
    x1: 26.8564,
    y1: 61.6151,
    x2: 27.6279,
    y2: 61.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_1723_16995",
    x1: 24.6355,
    y1: 61.6151,
    x2: 25.4069,
    y2: 61.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_1723_16995",
    x1: 22.4147,
    y1: 61.6151,
    x2: 23.1861,
    y2: 61.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_1723_16995",
    x1: 20.1936,
    y1: 61.6151,
    x2: 20.9651,
    y2: 61.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_1723_16995",
    x1: 17.9726,
    y1: 61.6151,
    x2: 18.7441,
    y2: 61.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_1723_16995",
    x1: 2.98572,
    y1: 58.4505,
    x2: 33.4355,
    y2: 58.4505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_1723_16995",
    x1: 2.98572,
    y1: 53.3217,
    x2: 33.4355,
    y2: 53.3217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_1723_16995",
    x1: 17.8249,
    y1: 55.8846,
    x2: 18.5964,
    y2: 55.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_1723_16995",
    x1: 15.604,
    y1: 55.8846,
    x2: 16.3755,
    y2: 55.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_1723_16995",
    x1: 13.3831,
    y1: 55.8846,
    x2: 14.1545,
    y2: 55.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_1723_16995",
    x1: 11.1621,
    y1: 55.8846,
    x2: 11.9336,
    y2: 55.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_1723_16995",
    x1: 8.94116,
    y1: 55.8846,
    x2: 9.7126,
    y2: 55.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_1723_16995",
    x1: 6.72031,
    y1: 55.8846,
    x2: 7.49175,
    y2: 55.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_1723_16995",
    x1: 4.4994,
    y1: 55.8846,
    x2: 5.27083,
    y2: 55.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_1723_16995",
    x1: 31.1506,
    y1: 55.8846,
    x2: 31.9221,
    y2: 55.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_1723_16995",
    x1: 28.9296,
    y1: 55.8846,
    x2: 29.701,
    y2: 55.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_1723_16995",
    x1: 26.7086,
    y1: 55.8846,
    x2: 27.48,
    y2: 55.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_1723_16995",
    x1: 24.4878,
    y1: 55.8846,
    x2: 25.2593,
    y2: 55.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_1723_16995",
    x1: 22.2668,
    y1: 55.8846,
    x2: 23.0383,
    y2: 55.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_1723_16995",
    x1: 20.0459,
    y1: 55.8846,
    x2: 20.8174,
    y2: 55.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_1723_16995",
    x1: 204.32,
    y1: 31.0586,
    x2: 68.5317,
    y2: 127.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_1723_16995",
    x1: 117.695,
    y1: 7.84766,
    x2: 84.0941,
    y2: 59.4719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_1723_16995",
    x1: 93.2027,
    y1: 61.5273,
    x2: 65.1831,
    y2: 84.5359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_1723_16995",
    x1: 130.094,
    y1: 22.6055,
    x2: 103.838,
    y2: 43.2072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_1723_16995",
    x1: 130.539,
    y1: 22.6523,
    x2: 112.261,
    y2: 41.9483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_1723_16995",
    x1: 116.535,
    y1: 15.3079,
    x2: 123.902,
    y2: 16.1489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE1AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCE79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_1723_16995",
    x1: 106.643,
    y1: 21.8969,
    x2: 114.447,
    y2: 22.2711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555EA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_1723_16995",
    x1: 108.172,
    y1: 19.0867,
    x2: 109.013,
    y2: 19.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555EA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51537A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_1723_16995",
    x1: 35.7522,
    y1: 16.473,
    x2: 27.1412,
    y2: 17.9584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE1AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCE79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_1723_16995",
    x1: 33.6921,
    y1: 18.3889,
    x2: 24.5497,
    y2: 17.0393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3A76B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_1723_16995",
    x1: 27.6746,
    y1: 19.5888,
    x2: 23.9724,
    y2: 18.2231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE1AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCE79"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1723_16995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 112,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployment);
export default __webpack_public_path__ + "static/media/employment.d849d7a2e9d5ace00312e0009aaf604a.svg";
export { ForwardRef as ReactComponent };